// Thin os-core wrapper that mounts the @os/vault sibling page. Mirrors
// KnowledgeWorkspacePage / LearningWorkspacePage.
import VaultPage from '@os/vault/web/pages/VaultPage'

export default function VaultWorkspacePage() {
  return <VaultPage />
}
